import { render, staticRenderFns } from "./RateCodeComponent.vue?vue&type=template&id=54a073ed&scoped=true"
import script from "./RateCodeComponent.vue?vue&type=script&lang=js"
export * from "./RateCodeComponent.vue?vue&type=script&lang=js"
import style0 from "./RateCodeComponent.vue?vue&type=style&index=0&id=54a073ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a073ed",
  null
  
)

export default component.exports